import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { InvoiceTable, StyledLinksSpan } from 'portal-modules/ledger/components'
import { ModalControl } from '@entrata/portals-common/lib/components'
import { InvoiceDocumentModal } from 'portal-modules/ledger/components/modals'
import { Document } from '@entrata/portals-common/lib/icons'
import { FocusSpan } from 'portal-modules/common/components/focus-styles'
import { StyledIconButton } from 'portal-modules/common/components/cards/atoms'
import styled from '@emotion/styled'
import getDateForLocale from 'portal-modules/common/utils/get-date-for-locale'

const CORRECTED_INVOICE_ID = '4'
const ORIGINAL_INVOICE_ID = '1'

const StyledDocumentSpan = styled('span')`
  color: ${({ theme }) => theme.secondary.base};
`
const StyledEm = styled('em')`
  font-size: 13px;
  color: ${({ theme }) => theme.text.light};
  display: block;
`

const StyledTime = styled('time')`
  color: ${({ theme }) => theme.text.light};
  font-style: italic;
`

const StyledAmtDetails = styled('section')`
  display: flex;
  flex-direction: column;
`

const StyledSpan = styled('span')`
  font-weight: bold;
  margin-left: 3px;
`

const CorrectedInvoices = props => {
  const { correctionsData, largeScreen, getColProps, token, history } = props

  return correctionsData.map(corrections => {
    return (
      <InvoiceTable.Row
        key={corrections.id}
        hasCorrections={corrections.invoice_type_id == ORIGINAL_INVOICE_ID}
      >
        <InvoiceTable.Col {...getColProps('invoice_number')} ischild={true}>
          {!!corrections.invoice_number && corrections.document_id ? (
            <ModalControl>
              {({ onClick, ref, ...modalProps }) => (
                <Fragment>
                  <Fragment>
                    <StyledSpan>
                      {corrections.invoice_type_id == CORRECTED_INVOICE_ID
                        ? __('Correction ')
                        : __('Original ')}
                    </StyledSpan>
                    <StyledLinksSpan onClick={onClick} ref={ref}>
                      <StyledIconButton>
                        {'( '}
                        <FocusSpan>
                          <Document size={12} />
                        </FocusSpan>
                      </StyledIconButton>
                      {corrections.invoice_number}
                      {')'}
                    </StyledLinksSpan>
                  </Fragment>
                  {!largeScreen ? (
                    <StyledEm>
                      {getDateForLocale(corrections.date)}
                    </StyledEm>
                  ) : (
                    ''
                  )}
                  {modalProps.show && (
                    <InvoiceDocumentModal
                      {...modalProps}
                      title={__('Customer Invoice - {%s, 0}', [
                        corrections.invoice_number,
                      ])}
                      document_id={corrections.document_id}
                      token={token}
                      history={history}
                    />
                  )}
                </Fragment>
              )}
            </ModalControl>
          ) : (
            <Fragment>
              <StyledSpan>
                {corrections.invoice_type_id == CORRECTED_INVOICE_ID
                  ? __('Correction ')
                  : __('Original ')}
              </StyledSpan>
              <StyledDocumentSpan>
                <StyledIconButton>
                  {'( '}
                  <FocusSpan>
                    <Document size={12} />
                  </FocusSpan>
                </StyledIconButton>
                {corrections.invoice_number}
                {')'}
              </StyledDocumentSpan>
              {!largeScreen ? (
                <StyledEm>
                  {' '}
                  {getDateForLocale(corrections.date)}
                </StyledEm>
              ) : (
                ''
              )}
            </Fragment>
          )}
        </InvoiceTable.Col>

        {largeScreen && (
          <Fragment>
            <InvoiceTable.Col {...getColProps('date')} ischild={true}>
              <StyledTime dateTime={corrections.date}>
                {getDateForLocale(corrections.date)}
              </StyledTime>
            </InvoiceTable.Col>
            <InvoiceTable.Col {...getColProps('amount')} ischild={true}>
              <StyledAmtDetails>
                <span>{i18nUtils.currency(corrections.amount)}</span>
              </StyledAmtDetails>
            </InvoiceTable.Col>
            <InvoiceTable.Col {...getColProps('tax')} ischild={true}>
              <StyledAmtDetails>
                <span>{i18nUtils.currency(corrections.total_taxes)}</span>
              </StyledAmtDetails>
            </InvoiceTable.Col>
          </Fragment>
        )}
        {!largeScreen && <InvoiceTable.Col {...getColProps('')} />}
        <InvoiceTable.Col {...getColProps('invoice_total')} ischild={true}>
          {corrections.is_negative_balance
            ? `(${i18nUtils.currency(corrections.total_invoice_amount)})`
            : i18nUtils.currency(corrections.total_invoice_amount)}
        </InvoiceTable.Col>
      </InvoiceTable.Row>
    )
  })
}

CorrectedInvoices.propTypes = {
  correctionsData: PropTypes.object,
  largeScreen: PropTypes.bool,
  token: PropTypes.string,
  getColProps: PropTypes.func,
  history: PropTypes.object,
}

CorrectedInvoices.defaultProps = {
  largeScreen: false,
}

export default CorrectedInvoices
